<template>
  <div v-if="system_setting">
    <!-- ヘッダー -->
    <v-row>
      <v-col cols="12">
        <h2>
          <v-icon class="mr-2">
            mdi-cog
          </v-icon>
          {{ terms.title }}
        </h2>
        <v-spacer class="mt-2" />
      </v-col>
    </v-row><!-- /ヘッダー -->

    <v-container>
      <v-card>
        <v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn
              color="primary"
              @click="editButtonClickEvent()"
            >
              編集
            </v-btn>
          </v-card-actions>

          <!-- 利用規約 -->
          <v-row>
            <v-col cols="12" md="12">
              <vue-editor
                v-model="system_setting[terms.content]"
                :corsProxy="true"
                :disabled="true"
                class="custom-quill-container"
              />
              <v-divider />
            </v-col>
          </v-row>
          <!-- /利用規約 -->
        </v-card-text>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'SystemShow',
  components: {},
  mixins: [],
  data () {
    return {
      system_setting: null
    }
  },
  computed: {
    type() {
      return this.$route.params.type
    },
    terms() {
      const map = { 
        emission: {
          title: '排出利用規約', 
          content: 'terms_of_emission'
        }, 
        edi_request: {
          title: 'EDI申請利用規約', 
          content: 'terms_of_edi_request'
        }
      }
      return map[this.type]
    } 
  },
  created() {
    this.showSystemSetting().then((content) => {
      this.system_setting = content
    })
  },
  methods: {
    ...mapActions('AdminSystemSetting', {
      showSystemSetting: 'show',
    }),
    editButtonClickEvent () {
      this.$router.push({name: 'AdminSystemEdit', params:{ type: this.type }})
    },
  }
}
</script>

<style scoped lang="scss">
.custom-quill-container {
  /deep/ {
    .ql-toolbar {
      display: none;
    }
    .ql-snow {
      border: none !important;
    }
  }
}
</style>
